<template>
  <v-responsive>
    <v-app
      :class="[$themeStore.theme, 'Roboto', 'horizontalLayout']"
      :theme="$themeStore.theme">
      <v-app-bar
        class="horizontalTopbar"
        elevation="0"
        height="80">
        <HorizontalHeader />
      </v-app-bar>
      <HorizontalSidebar v-if="$authStore.isAuthenticated" />

      <v-main>
        <v-container
          class="page-wrapper"
          fluid>
          <BackendWarningBanner />
          <RouterView />
        </v-container>
      </v-main>
    </v-app>
  </v-responsive>
</template>

<script lang="ts" setup>
import { RouterView } from 'vue-router';
import { onMounted } from 'vue';
import { msalService } from './config/useAuth';
import { msalInstance } from './config/msalConfig';
import HorizontalHeader from '@/layout/horizontal-header/HorizontalHeader.vue';
import { useThemeStore } from '@/stores/theme';
import HorizontalSidebar from '@/layout/horizontal-sidebar/HorizontalSidebar.vue';
import { useAuthStore } from '@/stores/auth.ts';
import BackendWarningBanner from '@/components/BackendWarningBanner.vue';

const $themeStore = useThemeStore();
const $authStore = useAuthStore();

const { handleRedirect } = msalService();

const initialize = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.log('Initialization error', error);
  }
};

onMounted(async () => {
  await initialize();
  await handleRedirect();
});
</script>
